// Dynamic Wood Stain Swatch Handler
// Integrates with the theme's variant system

function toHandle(str) {
  return str.toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[\/\.]/g, '-')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9\-]/g, '')
    .replace(/^(\d)/, '_$1'); // Prefix with underscore if starts with a number
}

function toHandle(str) {
  return str.toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[\/\.]/g, '-')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9\-]/g, '');
}

const speciesToClass = (species) => `.${toHandle(species)}_stain_swatch_set`;

function showSwatchesFor(species) {
  // Check if this is "As Shown" or similar wood type that doesn't need stain
  const speciesLower = species.toLowerCase().trim();
  const isAsShown = speciesLower.includes('as shown') || speciesLower === 'as-shown';
  
  // Hide all swatch containers
  document.querySelectorAll('.swatch-grid').forEach(el => {
    if (el.classList.contains('_stain_swatch_set')) {
      el.style.display = 'none';
    }
  });
  
  // Show the target species swatches (if not "As Shown")
  if (!isAsShown) {
    try {
      const target = document.querySelector(speciesToClass(species));
      if (target) {
        target.style.display = '';
        
        // Update the current species data attribute
        const woodStainPicker = document.querySelector('.wood-stain-picker');
        if (woodStainPicker) {
          woodStainPicker.setAttribute('data-current-species', species);
        }
      }
    } catch (e) {
      // Silently fail if selector is invalid
    }
  }
  
  // Handle the stain picker visibility
  const stainPicker = document.querySelector('.color-stain-picker');
  if (stainPicker) {
    if (isAsShown) {
      // **"As Shown" selected - hide stain picker and clear/bypass validation**
      stainPicker.style.display = 'none';
      stainPicker.setAttribute('data-hidden', 'true');
      stainPicker.setAttribute('data-no-stain-required', 'true');
      
      // Set hidden input to empty but mark it as not requiring validation
      const dynamicStainInput = document.getElementById('dynamic-stain-input');
      if (dynamicStainInput) {
        dynamicStainInput.value = '';
        dynamicStainInput.setAttribute('data-no-validation', 'true');
      }
      
      // Trigger IMMEDIATE validation update
      if (window.ProductCustomizationsManager) {
        window.ProductCustomizationsManager.updateAddToCartButtonState();
      }
      
      // Trigger event for product-customizations.js to re-check
      document.dispatchEvent(new CustomEvent('stain:not-required', { 
        bubbles: true,
        detail: { reason: 'as-shown' }
      }));
    } else {
      // **Regular wood type - show stain picker and require selection**
      stainPicker.style.display = '';
      stainPicker.removeAttribute('data-hidden');
      stainPicker.removeAttribute('data-no-stain-required');
      
      // Remove all checkmarks from ALL stain sets (visible and hidden)
      document.querySelectorAll('.checkmark').forEach(checkmark => {
        checkmark.remove();
      });
      
      // Uncheck ALL stain radio buttons across all wood types
      document.querySelectorAll('input[name="properties[Stain]"]').forEach(input => {
        input.checked = false;
        input.removeAttribute('checked');
      });
      
      // **CRITICAL: Clear the hidden input that stores the stain value**
      const dynamicStainInput = document.getElementById('dynamic-stain-input');
      if (dynamicStainInput) {
        dynamicStainInput.value = '';
        dynamicStainInput.removeAttribute('data-no-validation');
      }
      
      // Trigger IMMEDIATE validation update
      if (window.ProductCustomizationsManager) {
        window.ProductCustomizationsManager.updateAddToCartButtonState();
      }
      
      // Trigger event for product-customizations.js to re-check
      document.dispatchEvent(new CustomEvent('stain:required', { 
        bubbles: true,
        detail: { species: species }
      }));
    }
  }
}

// Hook into the theme's variant change events
document.addEventListener('variant:changed', (e) => {
  const variant = e.detail.variant;
  if (variant && variant.option1) {
    const species = variant.option1; // Wood species is typically option1
    // Only call showSwatchesFor if this looks like a wood type, not a size
    // Sizes typically contain numbers or x's (like "36" x 36"")
    const looksLikeSize = /\d+/.test(species) || species.includes('x') || species.includes('"');
    
    if (!looksLikeSize) {
      showSwatchesFor(species);
    }
  }
});

// Listen for direct wood species changes
document.addEventListener('change', (e) => {
  // Only respond to wood/species inputs, not size or other options
  const inputName = e.target.name ? e.target.name.toLowerCase() : '';
  
  // Check if this is specifically a wood or species selection
  if (e.target.matches('input[name*="Wood"], select[name*="Wood"], input[name*="Species"], select[name*="Species"]') ||
      (inputName.includes('wood') || inputName.includes('species'))) {
    const species = e.target.value;
    if (species) {
      showSwatchesFor(species);
    }
  }
});

// Function to update stain checkmark
function updateStainCheckmark(input) {
  const stainPicker = input.closest('.color-stain-picker');
  if (stainPicker) {
    // Remove all checkmarks from stain picker
    stainPicker.querySelectorAll('.checkmark').forEach(checkmark => {
      checkmark.remove();
    });
    
    // Add checkmark to selected swatch
    const selectedLabel = input.nextElementSibling;
    if (selectedLabel && selectedLabel.tagName === 'LABEL') {
      const checkmark = document.createElement('span');
      checkmark.className = 'checkmark';
      checkmark.textContent = '✓';
      selectedLabel.appendChild(checkmark);
    }
    
    // **CRITICAL: Update the hidden input with the selected stain value**
    const dynamicStainInput = document.getElementById('dynamic-stain-input');
    if (dynamicStainInput) {
      dynamicStainInput.value = input.value;
    }
  }
}

// Handle stain selection changes
document.addEventListener('change', (e) => {
  if (e.target.matches('input[name="properties[Stain]"]')) {
    updateStainCheckmark(e.target);
  }
});

// Also listen for input events (more immediate)
document.addEventListener('input', (e) => {
  if (e.target.matches('input[name="properties[Stain]"]')) {
    updateStainCheckmark(e.target);
  }
});

// Also handle stain selection via click (fallback)
document.addEventListener('click', (e) => {
  // Check if clicked on a stain label or its parent
  const stainLabel = e.target.closest('.color-stain-picker .swatch-element label');
  if (stainLabel) {
    const input = stainLabel.previousElementSibling;
    if (input && input.type === 'radio') {
      // Trigger change manually if needed
      setTimeout(() => {
        const stainPicker = input.closest('.color-stain-picker');
        if (stainPicker) {
          // Remove all checkmarks
          stainPicker.querySelectorAll('.checkmark').forEach(checkmark => {
            checkmark.remove();
          });
          
          // Add checkmark to this label
          if (!stainLabel.querySelector('.checkmark')) {
            const checkmark = document.createElement('span');
            checkmark.className = 'checkmark';
            checkmark.textContent = '✓';
            stainLabel.appendChild(checkmark);
          }
        }
      }, 10);
    }
  }
});

// Handle upholstery option selection changes
document.addEventListener('change', (e) => {
  if (e.target.matches('input[name="properties[Upholstery Option]"]')) {
    // Update checkmarks for upholstery swatches
    const upholsteryPicker = e.target.closest('.upholstery-picker');
    if (upholsteryPicker) {
      // Remove all checkmarks from upholstery picker
      upholsteryPicker.querySelectorAll('.checkmark').forEach(checkmark => {
        checkmark.remove();
      });
      
      // Add checkmark to selected swatch
      const selectedLabel = e.target.nextElementSibling;
      if (selectedLabel) {
        const checkmark = document.createElement('span');
        checkmark.className = 'checkmark';
        checkmark.textContent = '✓';
        selectedLabel.appendChild(checkmark);
      }
    }
  }
});

// Handle corian surface option selection changes
document.addEventListener('change', (e) => {
  if (e.target.matches('input[name="properties[Surface Option]"]')) {
    // Update checkmarks for corian swatches
    const corianPicker = e.target.closest('.corian-picker');
    if (corianPicker) {
      // Remove all checkmarks from corian picker
      corianPicker.querySelectorAll('.checkmark').forEach(checkmark => {
        checkmark.remove();
      });
      
      // Add checkmark to selected swatch
      const selectedLabel = e.target.nextElementSibling;
      if (selectedLabel) {
        const checkmark = document.createElement('span');
        checkmark.className = 'checkmark';
        checkmark.textContent = '✓';
        selectedLabel.appendChild(checkmark);
      }
    }
  }
});

// Handle metal accent option selection changes
document.addEventListener('change', (e) => {
  if (e.target.matches('input[name="properties[Metal Color Options]"]')) {
    const metalPicker = e.target.closest('.metal-accent-picker');
    if (metalPicker) {
      metalPicker.querySelectorAll('.checkmark').forEach(checkmark => {
        checkmark.remove();
      });

      const selectedLabel = e.target.nextElementSibling;
      if (selectedLabel) {
        const checkmark = document.createElement('span');
        checkmark.className = 'checkmark';
        checkmark.textContent = '✓';
        selectedLabel.appendChild(checkmark);
      }
    }
  }
});

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  // Initialize checkmarks for stain picker
  const stainPicker = document.querySelector('.color-stain-picker');
  if (stainPicker) {
    const checkedInputs = stainPicker.querySelectorAll('input[type="radio"][name="properties[Stain]"]:checked');
    checkedInputs.forEach(input => {
      const label = input.nextElementSibling;
      if (label && label.tagName === 'LABEL' && !label.querySelector('.checkmark')) {
        const checkmark = document.createElement('span');
        checkmark.className = 'checkmark';
        checkmark.textContent = '✓';
        label.appendChild(checkmark);
      }
    });
  }

  // Initialize checkmarks for upholstery picker
  const upholsteryPicker = document.querySelector('.upholstery-picker');
  if (upholsteryPicker) {
    upholsteryPicker.querySelectorAll('input[type="radio"]:checked').forEach(input => {
      const label = input.nextElementSibling;
      if (label && !label.querySelector('.checkmark')) {
        const checkmark = document.createElement('span');
        checkmark.className = 'checkmark';
        checkmark.textContent = '✓';
        label.appendChild(checkmark);
      }
    });
  }

  // Initialize checkmarks for corian picker
  const corianPicker = document.querySelector('.corian-picker');
  if (corianPicker) {
    corianPicker.querySelectorAll('input[type="radio"]:checked').forEach(input => {
      const label = input.nextElementSibling;
      if (label && !label.querySelector('.checkmark')) {
        const checkmark = document.createElement('span');
        checkmark.className = 'checkmark';
        checkmark.textContent = '✓';
        label.appendChild(checkmark);
      }
    });
  }

  // Initialize checkmarks for metal accent picker
const metalPicker = document.querySelector('.metal-accent-picker');
if (metalPicker) {
  metalPicker.querySelectorAll('input[type="radio"]:checked').forEach(input => {
    const label = input.nextElementSibling;
    if (label && !label.querySelector('.checkmark')) {
      const checkmark = document.createElement('span');
      checkmark.className = 'checkmark';
      checkmark.textContent = '✓';
      label.appendChild(checkmark);
    }
  });
}

  const woodStainPicker = document.querySelector('.wood-stain-picker');
  if (woodStainPicker) {
    const currentSpecies = woodStainPicker.querySelector('[data-current-species]')?.getAttribute('data-current-species');
    if (currentSpecies) {
      showSwatchesFor(currentSpecies);
    }
    
    // Initialize checkmarks for wood-stain-picker (legacy support)
    woodStainPicker.querySelectorAll('input[type="radio"]:checked').forEach(input => {
      const label = input.nextElementSibling;
      if (label && !label.querySelector('.checkmark')) {
        const checkmark = document.createElement('span');
        checkmark.className = 'checkmark';
        checkmark.textContent = '✓';
        label.appendChild(checkmark);
      }
    });
  }
  
  // **Check on page load if "As Shown" is selected**
  const selectedWoodOption = document.querySelector('input[name*="Wood"]:checked, select[name*="Wood"] option[selected], input[name*="Species"]:checked, select[name*="Species"] option[selected]');
  if (selectedWoodOption) {
    const selectedValue = selectedWoodOption.value || selectedWoodOption.textContent;
    const looksLikeAsShown = selectedValue.toLowerCase().includes('as shown');
    if (looksLikeAsShown) {
      setTimeout(() => {
        showSwatchesFor(selectedValue);
      }, 100);
    }
  }
});

// Integration with theme's variant selector
if (typeof window.VariantSelector !== 'undefined') {
  const originalVariantSelector = window.VariantSelector;
  
  // Extend the variant selector to handle stain swatches
  window.VariantSelector = class extends originalVariantSelector {
    constructor(element) {
      super(element);
      this.handleStainSwatches();
    }
    
    handleStainSwatches() {
      // Listen for variant changes and update stain swatches
      this.addEventListener('change', (e) => {
        if (e.target.name.includes('Wood') || e.target.name.includes('Species')) {
          const species = e.target.value;
          if (species) {
            showSwatchesFor(species);
          }
        }
      });
    }
  };
}

// Handle info button click interactions
document.addEventListener('click', (e) => {
  if (e.target.closest('.info-button')) {
    e.preventDefault();
    const button = e.target.closest('.info-button');
    const isActive = button.classList.contains('active');
    
    // Close all other active info buttons
    document.querySelectorAll('.info-button.active').forEach(btn => {
      if (btn !== button) {
        btn.classList.remove('active');
      }
    });
    
    // Toggle current button
    if (isActive) {
      button.classList.remove('active');
    } else {
      button.classList.add('active');
    }
  } else {
    // Close all info buttons when clicking elsewhere
    document.querySelectorAll('.info-button.active').forEach(btn => {
      btn.classList.remove('active');
    });
  }
});

document.addEventListener('submit', (e) => {
  if (e.target.matches('form[is="product-form"]')) {
    console.log('Product form submitted');
    
    // Ensure our properties are included in the form
    const woodStainPicker = document.querySelector('.wood-stain-picker');
    if (woodStainPicker) {
      // Get selected stain
      const selectedStain = woodStainPicker.querySelector('input[name="properties[Stain]"]:checked');
      if (selectedStain) {
        console.log('Selected stain:', selectedStain.value);
        // Ensure it's included in the form
        if (!e.target.querySelector(`input[name="properties[Stain]"][value="${selectedStain.value}"]`)) {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'properties[Stain]';
          hiddenInput.value = selectedStain.value;
          e.target.appendChild(hiddenInput);
        }
      }
      
      // Get selected upholstery option
      const selectedUpholstery = woodStainPicker.querySelector('input[name="properties[Upholstery Option]"]:checked');
      if (selectedUpholstery) {
        console.log('Selected upholstery option:', selectedUpholstery.value);
        // Ensure it's included in the form
        if (!e.target.querySelector(`input[name="properties[Upholstery Option]"][value="${selectedUpholstery.value}"]`)) {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'properties[Upholstery Option]';
          hiddenInput.value = selectedUpholstery.value;
          e.target.appendChild(hiddenInput);
        }
      }
    }

    // Get selected metal color option
const selectedMetal = woodStainPicker.querySelector('input[name="properties[Metal Color Options]"]:checked');
if (selectedMetal) {
  console.log('Selected metal color option:', selectedMetal.value);

  if (!e.target.querySelector(`input[name="properties[Metal Color Options]"][value="${selectedMetal.value}"]`)) {
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'properties[Metal Color Options]';
    hiddenInput.value = selectedMetal.value;
    e.target.appendChild(hiddenInput);
  }
}
    
    // Check if our properties are included
    const formData = new FormData(e.target);
    console.log('Form data entries:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
    
    // Specifically check for our properties
    const stainValue = formData.get('properties[Stain]');
    const upholsteryValue = formData.get('properties[Upholstery Option]');
    const metalValue = formData.get('properties[Metal Color Options]');

    console.log('Stain value:', stainValue);
    console.log('Upholstery Option value:', upholsteryValue);
    console.log('Metal Color Options value:', metalValue);
      }
});